import { useQuery } from '@tanstack/react-query';
import { transactionReportApi } from '../api/transactionReportApi';
import { TransactionReportFilterParams } from '../types/transaction-report.types';

export const useTransactionReport = (params: TransactionReportFilterParams) => {
  return useQuery({
    queryKey: ['transactionReport', params],
    queryFn: () => transactionReportApi.getTransactionReport(params),
    enabled: !!(params.fromDate && params.toDate), // Only fetch if date range is provided
  });
};

export const useExportTransactionReport = () => {
  const exportReport = async (params: TransactionReportFilterParams) => {
    try {
      const blob = await transactionReportApi.exportTransactionReportCSV(params);
      
      // Create download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Generate filename with date range
      const fromDate = params.fromDate || 'unknown';
      const toDate = params.toDate || 'unknown';
      link.setAttribute('download', `TransactionReport_${fromDate}_to_${toDate}.csv`);
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting transaction report:', error);
      throw error;
    }
  };

  return { exportReport };
};
